import { render, staticRenderFns } from "./MatchPredictionsBar.vue?vue&type=template&id=66065865&"
import script from "./MatchPredictionsBar.vue?vue&type=script&lang=js&"
export * from "./MatchPredictionsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports